/**
 * Section Store cart: force "Combínalo con.." to bolsos + pendientes
 * (manual upsell) instead of auto related recommendations.
 */
(function () {
  var ATTR = 'data-config';
  var FLAG = '__orBolsosPendientes';

  // Interleaved: bolsos + pendientes (available products)
  var PRODUCT_GIDS = [
    'gid://shopify/Product/16638525309273', // Bolso Nube Viral
    'gid://shopify/Product/16635907735897', // Odessa | Pendientes - Plata
    'gid://shopify/Product/16638512726361', // Mini bolso
    'gid://shopify/Product/16635907637593', // Milan | Pendientes corazón - Plata
    'gid://shopify/Product/16638507876697', // Maelis retro bag
    'gid://shopify/Product/16635907506521', // Milan | Pendientes corazón - Oro
    'gid://shopify/Product/16638503616857', // Bolso Cherry
    'gid://shopify/Product/16635907375449', // Davina | Pendientes - Plata
    'gid://shopify/Product/16638499193177', // Bolso Ciela
    'gid://shopify/Product/16635907047769', // Therese | Pendientes - Perla
  ];

  function buildRule() {
    return {
      short_id: 'orBp',
      priority: 1,
      trigger_type: 'all_products',
      recommended_product_gids: PRODUCT_GIDS.slice(),
      recommended_products: PRODUCT_GIDS.map(function (gid) {
        return { product_gid: gid, variant_gids: [] };
      }),
    };
  }

  var TITLES = {
    es: 'Combínalo con..',
    en: 'Pair it with..',
    fr: 'À associer avec..',
    de: 'Dazu passt..',
    pt: 'Combina com..',
    'pt-pt': 'Combina com..',
  };

  function upsellTitle() {
    var lang = 'es';
    try {
      lang = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'es';
    } catch (e) {}
    lang = String(lang).toLowerCase();
    if (TITLES[lang]) return TITLES[lang];
    if (lang.indexOf('pt') === 0) return TITLES.pt;
    if (lang.indexOf('en') === 0) return TITLES.en;
    if (lang.indexOf('fr') === 0) return TITLES.fr;
    if (lang.indexOf('de') === 0) return TITLES.de;
    return TITLES.es;
  }

  function patch(el) {
    if (!el || !el.getAttribute) return false;
    var raw = el.getAttribute(ATTR);
    if (!raw) return false;
    var cfg;
    try {
      cfg = JSON.parse(raw);
    } catch (e) {
      return false;
    }
    if (!cfg || !cfg.products_upsell) return false;
    if (cfg.products_upsell[FLAG]) return true;

    cfg.products_upsell.enabled = true;
    cfg.products_upsell.upsell_type = 'manual';
    cfg.products_upsell.title = upsellTitle();
    cfg.products_upsell.rules = [buildRule()];
    cfg.products_upsell[FLAG] = true;

    el.setAttribute(ATTR, JSON.stringify(cfg));
    return true;
  }

  function translateHeadings(root) {
    var title = upsellTitle();
    if (title === TITLES.es) return;
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll ? scope.querySelectorAll('h1, h2, h3, h4') : [];
    for (var i = 0; i < nodes.length; i++) {
      var text = (nodes[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (text === 'Combínalo con..' || text === 'Combínalo con.' || text === 'Combínalo con') {
        nodes[i].textContent = title;
      }
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll
      ? scope.querySelectorAll('section-store--cart-block')
      : [];
    for (var i = 0; i < nodes.length; i++) patch(nodes[i]);
    if (scope.nodeName === 'SECTION-STORE--CART-BLOCK') patch(scope);
    translateHeadings(scope);
  }

  scan(document);
  setTimeout(function () {
    scan(document);
  }, 400);
  document.addEventListener(
    'click',
    function () {
      setTimeout(function () {
        translateHeadings(document);
      }, 60);
    },
    true,
  );

  try {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' && m.attributeName === ATTR && m.target) {
          patch(m.target);
        }
        var nodes = m.addedNodes || [];
        for (var j = 0; j < nodes.length; j++) {
          if (nodes[j].nodeType === 1) scan(nodes[j]);
        }
      }
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [ATTR],
    });
  } catch (e) {}
})();
